/* eslint-disable @typescript-eslint/camelcase */

import urlcat from 'urlcat';

import createClient, { UsersEndpoint, SocialProvidersAction } from '@/api/xsolla/client';

export default class SocialProviders {
  static client = createClient(UsersEndpoint.SOCIAL_PROVIDERS);

  static async linked() {
    return this.client.get(SocialProvidersAction.LINKED_PROVIDERS);
  }

  static async loginUrl(provider: string, loginUrl?: string) {
    const action = urlcat(SocialProvidersAction.PROVIDER_LOGIN_URL, {
      provider,
      login_url: loginUrl,
    });

    return this.client.get(action);
  }
}
